import { toast } from 'react-toastify'

/**
 * Shows API validation errors as one toast per Joi `details` entry, or a single toast for a string message.
 *
 * @param {*} message - `error.data.message`: string, or object with `details: [{ message }]`
 * @param {string} [fallback] - Used when message is missing or unrecognised
 */
export function toastApiValidationErrors(message, fallback = '') {
  if (message == null || message === '') {
    if (fallback) toast.error(fallback)
    return
  }

  if (typeof message === 'string') {
    toast.error(message)
    return
  }

  if (typeof message === 'object') {
    const details = message.details ?? message.detailes
    if (Array.isArray(details) && details.length > 0) {
      let count = 0
      details.forEach((d) => {
        const text = typeof d?.message === 'string' ? d.message : null
        if (text) {
          toast.error(text)
          count += 1
        }
      })
      if (count > 0) return
    }

    if (typeof message.message === 'string') {
      toast.error(message.message)
      return
    }
  }

  if (fallback) toast.error(fallback)
}
